var map = {
	"./de/impressum.mdx": [
		66981,
		66981
	],
	"./de/index.mdx": [
		13288,
		13288
	],
	"./de/rechtliche-grundlagen.mdx": [
		9555,
		9555
	],
	"./en/imprint.mdx": [
		9787,
		9787
	],
	"./en/index.mdx": [
		9900,
		9900
	],
	"./en/legal-framework.mdx": [
		80212,
		80212
	],
	"./fr/cadre-juridique.mdx": [
		96741,
		96741
	],
	"./fr/impressum.mdx": [
		21368,
		21368
	],
	"./fr/index.mdx": [
		94921,
		94921
	],
	"./it/colophon.mdx": [
		38560,
		38560
	],
	"./it/index.mdx": [
		80350,
		80350
	],
	"./it/quadro-giuridico.mdx": [
		45508,
		45508
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70227;
module.exports = webpackAsyncContext;